var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import moment from "moment";
import { keys } from "ramda";
import React, { useState } from "react";
import uuid from "uuid";
import { currencyFromCountry } from "../../data";
import { Money } from "../../data/Money";
import { Select } from "@material-ui/core";
import { Link } from "react-router-dom";
import EnterpriseSelect from "../common/EnterpriseSelect";
import InputField from "../common/InputField";
function validate(values) {
    var errors = {};
    if (values.product === "-1") {
        errors.product = "A product must be chosen";
    }
    if (!values.start) {
        errors.startDate = "You must provide a value";
    }
    if (values.length <= 0) {
        errors.length = "Duration must be at least 1 month";
    }
    if (values.enterprise === "none") {
        errors.enterprises = "Order must be associated with an enterprise";
    }
    return errors;
}
var WizardFormSecondPage = function (props) {
    var _a;
    var oldOrder = props.oldOrder, currentUser = props.currentUser, products = props.products, previousPage = props.previousPage, storeOrder = props.storeOrder, customer = props.customer;
    var _b = useState(oldOrder
        ? oldOrder
        : {
            id: uuid.v1(),
            user: (_a = customer === null || customer === void 0 ? void 0 : customer.id) !== null && _a !== void 0 ? _a : "",
            agent: currentUser.id,
            enterprise: "none",
            locations: 0,
            videos: 0,
            monthly: new Money(0, currencyFromCountry(currentUser.country)),
            fee: new Money(0, currencyFromCountry(currentUser.country)),
            discount: 0,
            start: new Date(),
            end: new Date(),
            length: 0,
            premium: false,
            status: "pending",
            created: new Date(),
            updated: new Date(),
            comment: "",
            product: "-1",
        }), order = _b[0], setOrder = _b[1];
    function countryFilter(product) {
        var _a;
        return (_a = product.country === (customer === null || customer === void 0 ? void 0 : customer.country)) !== null && _a !== void 0 ? _a : "DE";
    }
    var productList = __spreadArrays([
        React.createElement("option", { key: "none", value: "-1" }, "---")
    ], products.filter(countryFilter).map(function (product) { return (React.createElement("option", { key: product.id, value: product.id },
        product.name,
        " - ",
        product.price.amount,
        " ",
        product.price.currency,
        " per month - ",
        product.locations,
        " ",
        "locations")); }));
    var errors = validate(order);
    var productSelect = (React.createElement("div", { className: "col s12 m6" },
        React.createElement("label", null, "Product"),
        React.createElement(Select, { className: "select", placeholder: "Product", name: "product", readOnly: props.editMode, disabled: props.editMode, onChange: function (e) {
                var product = props.products.find(function (p) { return p.id === e.target.value; });
                setOrder(__assign(__assign({}, order), { product: product.id, enterprise: product.enterprise }));
            }, value: order.product }, productList),
        React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, errors.product && errors.product)));
    return (React.createElement("form", { className: "order__form_step", onSubmit: function (e) { return e.preventDefault(); } },
        productSelect,
        order.product !== "-1" && (React.createElement(EnterpriseSelect, { value: order.enterprise, enterprises: props.enterprises, setEnterprise: function (id) { return setOrder(__assign(__assign({}, order), { enterprise: id })); }, error: errors.enterprise })),
        React.createElement(InputField, { type: "date", label: "Start Date", placeholder: "DD-MM-YYYY", value: moment(order.start).format("YYYY-MM-DD"), onChange: function (date) {
                setOrder(__assign(__assign({}, order), { start: moment(date, "YYYY-MM-DD").toDate() }));
            }, meta: { touched: true, error: errors.start } }),
        React.createElement(InputField, { type: "number", label: "Duration", placeholder: "Duration in months", value: order.length, onChange: function (duration) {
                var length = parseInt(duration, 10);
                var end = moment(order.start)
                    .add(length, "months")
                    .toDate();
                setOrder(__assign(__assign({}, order), { end: end, length: length }));
            }, meta: { touched: true, error: errors.length } }),
        React.createElement(InputField, { type: "number", label: "Discount", placeholder: "Discount in %", value: order.discount, onChange: function (discount) { return setOrder(__assign(__assign({}, order), { discount: parseInt(discount, 10) })); } }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(InputField, { type: "text", label: "Comment", placeholder: "Comment (e.g. reason for discount)", value: order.comment ? order.comment : "", onChange: function (comment) { return setOrder(__assign(__assign({}, order), { comment: comment })); } }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { className: "col s12 m10" },
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { type: "button", className: "previous white btn-flat left red-text", onClick: function () { return previousPage(order); } }, "Previous"),
            React.createElement("button", { type: "submit", className: "right teal btn-flat btn white-text next", onClick: function () { return storeOrder(order); }, disabled: keys(errors).length > 0 }, "Next"),
            React.createElement(Link, { to: "/orders", className: "right white btn-flat left red-text" }, "Cancel"))));
};
export default WizardFormSecondPage;



//////////////////
// WEBPACK FOOTER
// ./src/components/orders/OrderFormSecondStep.tsx
// module id = 1238
// module chunks = 0